import { type PropsWithChildren } from 'react';
import { Outlet } from 'react-router';
import { SuspenseBoundary } from '@repo/shared-kit/components/suspense-boundary/suspense-boundary';
import { KycError } from '#error/error';
import { useKycContext } from '#context/kyc-context';
import { KycPageLoading } from '#loading/loading';

export function KycSuspenseBoundary({ children = <Outlet /> }: PropsWithChildren) {
  const { onError, isFullHeight } = useKycContext();
  return (
    <SuspenseBoundary
      errorFallback={({ onRetry }) => <KycError onRetry={onRetry} />}
      loadingFallback={<KycPageLoading isFullHeight={isFullHeight} />}
      onError={onError}
    >
      {children}
    </SuspenseBoundary>
  );
}
